import { LoaderProps } from "./Interfaces";
import "./Loader.scss";

export function Loader({ hasError, styleClass }: LoaderProps): JSX.Element 
{
  return (hasError ?
    <div className="card my-5">
      <div className="card-header text-center">
        <p>
          There was an error in language loading.{' '}
          <span
            style={{ cursor: 'pointer', color: '#0077FF' }}
            onClick={() => {
              window.location.reload();
            } }
          >
            Reload this page
          </span>{' '}
        </p>
      </div>
    </div>
    :
    <>
      <div className={`d-flex justify-content-center pad-10 ${styleClass}`}>
        <div className="spinner-border spinner-style" role="status" attr-test="loader">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </>);
}

export default Loader;